
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.147","height":"15.147"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_48224","data-name":"Group 48224"}},[_c('rect',{attrs:{"id":"Rectangle_16385","data-name":"Rectangle 16385","width":"15.147","height":"15.147","fill":"none"}}),_c('g',{attrs:{"id":"Group_48225","data-name":"Group 48225"}},[_c('g',{attrs:{"id":"Group_48227","data-name":"Group 48227","fill":"none","stroke":"#727998","stroke-linecap":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_37708","data-name":"Path 37708","d":"M12.816 3.746a1.2 1.2 0 011.2 1.2v6.878a1.2 1.2 0 01-1.2 1.2H2.332a1.2 1.2 0 01-1.2-1.2V4.948a1.2 1.2 0 011.2-1.2h-.061","stroke-linejoin":"round"}}),_c('path',{attrs:{"id":"Path_37709","data-name":"Path 37709","d":"M.5 0H5a.5.5 0 01.5.5v7A.5.5 0 015 8H.5a.5.5 0 01-.5-.5v-7A.5.5 0 01.5 0z","transform":"translate(4.823 2.124)"}})])])])])
          )
        }
      }
    